import React from 'react'
import { makeStyles, Theme, Typography, Link, Button } from '@material-ui/core/'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import ResponsiveModal, { ModalSizes } from '@src/components/ResponsiveModal'

const useStyles = makeStyles((theme: Theme) => ({
  modalBodyContainer: {
    padding: theme.spacing(4),
    overflow: 'auto',
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(8),
    },
  },
  descriptionFont: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightBold,
  },
  contentPadding: {
    padding: theme.spacing(6, 0, 0),
  },
  closeButton: {
    marginTop: theme.spacing(15),
    float: 'right',
  },
}))

interface ScanNowAiModalProps {
  isAiInfoOpen: boolean
  setAiInfoOpen: (value: boolean) => void
}

const ScanNowAiModal: React.FC<ScanNowAiModalProps> = ({
  isAiInfoOpen,
  setAiInfoOpen,
}) => {
  const classes = useStyles()

  return (
    <ResponsiveModal
      size={ModalSizes.Large}
      open={isAiInfoOpen}
      onClose={() => setAiInfoOpen(false)}
      renderTitle={() => (
        <Typography variant="h2" component="h2">
          <FormattedMessage {...messages.APPLICATION_IDENTIFIERS_ABOUT} />
        </Typography>
      )}
    >
      <div className={classes.modalBodyContainer}>
        <div>
          <FormattedMessage
            {...messages.APPLICATION_IDENTIFIERS_LINE1}
            values={{
              link: (
                <Link
                  href="https://www.gs1.org/about/what-we-do"
                  target="_blank"
                >
                  <FormattedMessage
                    {...messages.APPLICATION_IDENTIFIERS_ABOUT_GS1}
                  />
                </Link>
              ),
            }}
          />
        </div>
        <div className={classes.contentPadding}>
          <FormattedMessage
            {...messages.APPLICATION_IDENTIFIERS_LINE2}
            values={{
              b: (value) => <strong>{value}</strong>,
            }}
          />
        </div>
        <div className={classes.contentPadding}>
          <FormattedMessage {...messages.APPLICATION_IDENTIFIERS_LINE3} />
        </div>
        <div className={classes.contentPadding}>
          <FormattedMessage
            {...messages.APPLICATION_IDENTIFIERS_LINE4}
            values={{
              b: (value) => <strong>{value}</strong>,
            }}
          />
        </div>
        <div className={classes.contentPadding}>
          <FormattedMessage
            {...messages.APPLICATION_IDENTIFIERS_LINE5}
            values={{
              gs1Website: (
                <Link
                  href="https://www.gs1.org/standards/barcodes/application-identifiers"
                  target="_blank"
                >
                  <FormattedMessage {...messages.GS1_WEBSITE_HERE} />
                </Link>
              ),
              gs1Standard: (
                <Link
                  href="https://www.gs1.org/standards/barcodes-epcrfid-id-keys/gs1-general-specifications"
                  target="_blank"
                >
                  <FormattedMessage {...messages.GS1_STANDARD_HERE} />
                </Link>
              ),
            }}
          />
        </div>
        <div className={classes.contentPadding}>
          <FormattedMessage {...messages.APPLICATION_IDENTIFIERS_LINE6} />
        </div>
        <div className={classes.closeButton}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => setAiInfoOpen(false)}
          >
            <FormattedMessage {...messages.OK} />
          </Button>
        </div>
      </div>
    </ResponsiveModal>
  )
}

export default ScanNowAiModal
